
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DashboardNavbar } from '@/views/layout/components'
import { AppModule } from '@/store/modules/app'
import { DASHAPI } from '@/api/dashboard'
import { AUDITAPI } from '@/api/statistic'
import { LIVEAUDIAPI } from '@/api/live'
import { NETWORKAUDIAPI } from '@/api/network'
import { getuserCurrentApp } from '@/utils/cookies'
import { timestampToDate } from '@/utils/commonFunc'
import { ADMINISAUDIAPI } from '@/api/administration'

@Component({
  components: {
    DashboardNavbar
  }
})
export default class Dashboard extends Vue {
  private lineDataIt = [];
  private lineDataLive = [];
  private lineDataNetwork = [];
  private lineDateRange = [];
  private linePeriod = 'week';
  private tableData: any = [];
  private tableLoading = true;
  private itSLAData = { recv_sla: 0, finish_sla: 0 };
  private adminSLAData = { recv_sla: 0, finish_sla: 0 };

  private liveSLAData = {
    official: { recv_sla: 0, finish_sla: 0 },
    not_official: { recv_sla: 0, finish_sla: 0 }
  };

  private networkSLAData = { recv_sla: 0, finish_sla: 0, total_rate: 0 };
  private pieChildData = {};
  private tableColumns = [
    { label: '待受理' },
    { label: '处理中' },
    { label: '已完成' },
    // { label: '已驳回' },
    // { label: '已撤销' },
    // { label: '已挂起' }
  ];

  private globalLoadingList = [false, false, false, false];

  private pieChartLoading = true;

  // navbar日期值
  get navbarDate() {
    return AppModule.navbarDate.length === 0
      ? [
        timestampToDate(new Date().getTime() - 3600 * 1000 * 24 * 7),
        timestampToDate(new Date().getTime())
      ]
      : AppModule.navbarDate
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  @Watch('navbarDate')
  private onNavbarDateChange() {
    this.globalLoadingList = [false, false, false, false]
    this.getAllTableData()
    this.getAllSlaData()
    this.getAllTicketChartData()
    this.getAllIssueTypeChartData()
  }

  mounted() {
    AppModule.SetShowNavbarDate(true)
    this.globalLoadingList = [false, false, false, false]
    this.getAllTableData()
    this.getAllSlaData()
    setTimeout(() => {
      this.getAllTicketChartData()
      this.getAllIssueTypeChartData()
    }, 500)
  }

  private expireTimeOption: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  };

  // 权限校验
  private preCheckPerms() {}

  // SLA获取
  private getAllSlaData() {
    const commonParams = {
      from: this.navbarDate ? this.navbarDate[0] : '',
      to: this.navbarDate ? this.navbarDate[1] : ''
    }
    const itSLA = AUDITAPI.getSystemSLAData({ app_id: 1, ...commonParams })
    const liveSLA = LIVEAUDIAPI.getSystemSLAData({
      app_id: 2,
      ...commonParams
    })
    const networkSLA = NETWORKAUDIAPI.getSystemSLAData({
      app_id: 3,
      ...commonParams
    })
    // const adminSLA = ADMINISAUDIAPI.getSystemSLAData({
    //   app_id: 5,
    //   ...commonParams
    // })
    return Promise.all([itSLA, liveSLA, networkSLA]).then((res) => {
      this.globalLoadingList[1] = true
      this.itSLAData = res[0].data
      this.liveSLAData = res[1].data
      this.networkSLAData = res[2].data
      // this.adminSLAData = res[3].data
    })
  }

  // table数据获取
  private getAllTableData() {
    const commonParams = {
      from: this.navbarDate ? this.navbarDate[0] : '',
      to: this.navbarDate ? this.navbarDate[1] : '',
      audit_type: 'ticket'
    }
    const itTable = AUDITAPI.getAllAudit({ app_id: 1, ...commonParams })
    // const liveTable = LIVEAUDIAPI.getAllAudit({ app_id: 2, ...commonParams })
    const networkTable = NETWORKAUDIAPI.getAllAudit({
      app_id: 3,
      ...commonParams
    })
    // const adminisTable = ADMINISAUDIAPI.getAllAudit({
    //   app_id: 5,
    //   ...commonParams
    // })
    // return Promise.all([itTable, liveTable, networkTable])
    return Promise.all([itTable, networkTable])

      .then((res) => {
        this.globalLoadingList[0] = true
        const itTableData = {
          group: 'IT',
          data: res[0].data.total,
          total: res[0].data.count
        }

        const liveData = res[1].data.total
        liveData.push({
          name: '已挂起',
          status: 6,
          value: 0
        })
        // const liveTableData = {
        //   group: '直播保障',
        //   data: liveData,
        //   total: res[1].data.count
        // }
        const networkData = res[1].data.total
        networkData.push({
          name: '已挂起',
          status: 6,
          value: 0
        })
        const networkTableData = {
          group: '网络',
          data: networkData,
          total: res[1].data.count
        }
        // const adminData = res[3].data.total
        // const adminTableData = {
        //   group: '行政',
        //   data: adminData,
        //   total: res[3].data.count
        // }
        // this.tableData = [liveTableData, itTableData, networkTableData]
        this.tableData = [itTableData, networkTableData]

        this.tableLoading = false
      })
      .catch((_) => {
        this.tableLoading = false
      })
      .finally(() => {
        this.tableLoading = false
      })
  }

  private handleChangeSelect() {
    this.getAllTicketChartData()
  }

  // 工单折线图获取
  private async getAllTicketChartData() {
    await DASHAPI.getChartAggrate({
      period: this.linePeriod,
      from: this.navbarDate ? this.navbarDate[0] : '',
      to: this.navbarDate ? this.navbarDate[1] : '',
      app_id: this.userCurrentApp
    }).then((res) => {
      this.globalLoadingList[2] = true
      if (res.stat === 1) {
        const data = res.data
        this.lineDateRange = data.date
        this.lineDataIt = data.it
        this.lineDataLive = data.live
        this.lineDataNetwork = data.network
        this.$nextTick(() => {
          this.drawLineChart()
        })
      }
    })
  }

  // 折线图
  private drawLineChart() {
    const lineChart = this.$echarts.init(
      document.getElementById('lineChartDiv')
    )
    lineChart.setOption(this.setLineEchartOption())

    window.addEventListener('resize', () => {
      lineChart.resize()
    })
  }

  private setLineEchartOption() {
    return {
      title: {
        text: '工单周期趋势图'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['IT', '网络']
        // data: ['直播保障', 'IT', '网络']
      },
      color: ['#4B8535', '#B11E3E', '#4396D3'],
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          rotate: 45,
          formatter: function (value: string) {
            return value.substr(0, value.indexOf('('))
          }
        },
        data: this.lineDateRange
      },
      yAxis: {
        type: 'value'
      },
      series: [
        // {
        //   name: '直播保障',
        //   type: 'line',
        //   data: this.lineDataLive
        // },
        {
          name: 'IT',
          type: 'line',
          data: this.lineDataIt
        },
        {
          name: '网络',
          type: 'line',
          data: this.lineDataNetwork
        }
      ]
    }
  }

  private async getAllIssueTypeChartData() {
    await DASHAPI.getIssueTypeAggrate({
      from: this.navbarDate ? this.navbarDate[0] : '',
      to: this.navbarDate ? this.navbarDate[1] : '',
      app_id: this.userCurrentApp
    })
      .then((res) => {
        this.globalLoadingList[3] = true
        if (res.stat === 1) {
          this.pieChildData = res.data.level_2_audit
          this.pieChartLoading = false
          this.$nextTick(() => {
            this.drawPieChart('问题总览', res.data.level_1_audit, 0)
            let index = 0
            for (const i in this.pieChildData) {
              index++
              this.drawPieChart(i, (this.pieChildData as any)[i], index)
            }
          })
        } else {
          this.pieChartLoading = false
        }
      })
      .catch((_) => (this.pieChartLoading = false))
  }

  // 饼图
  private drawPieChart(title: string, data: [], index: number) {
    const pieChart = this.$echarts.init(
      document.getElementById('pieEcharts' + index)
    )
    pieChart.setOption(this.setPieEchartOption(title, data))
    window.addEventListener('resize', () => {
      pieChart.resize()
    })
  }

  private setPieEchartOption(titleName: string, data: any) {
    // 去除值为0的数据，不展示
    let newPieData: any = []
    let count = 0
    data.forEach((item: any) => {
      if (item.value > 0) {
        count++
        newPieData.push(item)
      }
    })
    if (count === 0) {
      // 所有数据都为0时显示
      newPieData = data
    }
    return {
      title: {
        text: titleName,
        left: 'center',
        padding: 20
      },
      color: [
        '#5e83fb',
        '#36cbcb',
        '#3aa1ff',
        '#4ecb73',
        '#9bd344',
        '#f8da47',
        '#ffbb67',
        '#ee706d',
        '#806dee',
        '#7c8cf5'
      ],
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} 个'
      },
      series: [
        {
          name: titleName,
          type: 'pie',
          radius: ['45%', '65%'],
          minAngle: 10,
          top: 20,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 1
          },
          labelLine: {
            normal: {
              length: '30',
              length2: '30',
              // length2: Math.max(30, Number(`${0.2 * 100 * window.innerWidth / 750}`)),
              position: 'outer',
              color: '#3d4954',
              padding: [0],
              smooth: 0.1
            }
          },
          label: {
            normal: {
              formatter: '{c|{c}}个({a|{d}%})\n{b|{b}}',
              borderWidth: 0,
              borderRadius: 4,
              shadowColor: '#999',
              padding: [0, -8 * 3.5],
              color: '#3d4954',
              rich: {
                a: {
                  // 百分比
                  align: 'left',
                  color: '#3d4954',
                  lineHeight: 10
                },
                b: {
                  // 百分比说明
                  align: 'left',
                  color: '#3d4954',
                  lineHeight: 10
                }
              }
            }
          },
          data: newPieData
        }
      ]
    }
  }
}
